import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './not-found/not-found.component';
import { DeleteSubmissions } from './delete-submissions/delete-submissions.component';
import { NotAuthorizedComponent } from './notauthorized/not-authorized.component';
import { Routes, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatDialogModule } from '@angular/material/dialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMarkjsModule } from 'ngx-markjs';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExpandViewComponent } from './expand-view/expand-view.component';
import { TranslateComponent } from './translate/translate.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';

// The new Report Components
import { ReportComponent as ReportComponentv2 } from './report-v2/report.component'; // The  new ReportComponent
import { BannerComponent } from './report-v2/components/panel-components/banner/banner.component';
import { ScoreComponent } from './report-v2/components/sidebar-components/score/score.component';
import { MatchingSources } from './report-v2/components/sidebar-components/matching-sources/matching-sources.component';
import { AiBar } from './report-v2/components/sidebar-components/ai-bar/ai-bar.component';
import { LanguageBar } from './report-v2/components/sidebar-components/lang-bar/language-bar.component';
import { Manipulation } from './report-v2/components/sidebar-components/manipulation/manipulation.component';
import { DocumentNavigation } from './report-v2/components/panel-components/navigation/navigation.component';
import { DocumentComponent } from './report-v2/components/panel-components/document/document.component';
import { LegendComponent } from './report-v2/components/panel-components/legend/legend.component';
import { OverviewDisclaimerComponent } from './report-v2/components/shared/overview-disclaimer/overview-disclaimer.component';
import { MetadataComponent } from './report-v2/components/sidebar-components/metadata/metadata.component';
import { PrivacySettingsModalComponent } from './report-v2/components/shared/privacy-settings-modal/privacy-settings-modal.component';
import { OfflineReportModalComponent } from './report-v2/components/shared/offline-report-modal/offline-report-modal.component';
import { SentenceInformationComponent } from './report-v2/components/sentence-information/sentence-information.component';
import { AiSentenceAnalysisComponent } from './report-v2/components/ai-sentence-analysis/ai-sentence-analysis.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CohortComponent } from './report-v2/components/cohort/cohort.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SourcePreviewComponent } from './report/sourcePreview/source-preview/source-preview.component';
import { AiAnalysisComponent } from './report-v2/components/sidebar-components/metadata/ai_analysis/ai_analysis.component';
import { Severity } from './report-v2/components/shared/severity/severity.component';
import { StylometricsComponent } from './report-v2/components/sidebar-components/stylometrics/stylometrics.component';
import { StylometricAnalysisComponent } from './report-v2/components/panel-components/stylometric-analysis/stylometric-analysis.component';
import { CustomInfoComponent } from './report-v2/components/shared/custom-info/custom-info.component';
import { PdfViewerComponent } from './report-v2/components/pdf-viewer/pdf-viewer.component';
import { AccessibleTooltipDirective } from './directives/accessible-tooltip.directive';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    NotAuthorizedComponent,
    NotFoundComponent,
    DeleteSubmissions,
    ExpandViewComponent,
    TranslateComponent,
    ReportComponentv2,
    BannerComponent,
    ScoreComponent,
    MatchingSources,
    AiBar,
    LanguageBar,
    Manipulation,
    DocumentNavigation,
    DocumentComponent,
    LegendComponent,
    PrivacySettingsModalComponent,
    OfflineReportModalComponent,
    SentenceInformationComponent,
    AiSentenceAnalysisComponent,
    CohortComponent,
    OverviewDisclaimerComponent,
    SourcePreviewComponent,
    MetadataComponent,
    AiAnalysisComponent,
    Severity,
    StylometricsComponent,
    StylometricAnalysisComponent,
    CustomInfoComponent,
    PdfViewerComponent,
    AccessibleTooltipDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
    MatDialogModule,
    NgxPaginationModule,
    PdfViewerModule,
    NgxMarkjsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgxFileDropModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    NgApexchartsModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    DragDropModule,
  ],
  exports: [TranslateModule, PdfViewerComponent],
})
export class SharedModule { }
